export default __webpack_public_path__ + "static/media/Flag_of_Somalia.88a25814.svg";